// extracted by mini-css-extract-plugin
export var modal = "_ca-0";